<template>
  <div class="window-box">
    <div class="step-nav">
      <div class="nav-item active">
        <span class="sort">1</span>志愿者登录
      </div>
      <span :class="['split-line', {'active': second}]"></span>
      <div :class="['nav-item', {'active': second}]">
        <span class="sort">2</span>成功
      </div>
    </div>

    <div class="main-window-s">
      <div class="title">志愿者登录</div>
      <template v-if="fir">
        <div class="content">
          <div class="form-box">
            <div class="item">
              <p>手机号</p>
              <input placeholder="请输入手机号" v-model="phoneNumber" />
            </div>
            <div class="item">
              <p>验证码</p>
              <div class="code-box">
                <input
                  placeholder="请输入验证码"
                  class="inputRequired"
                  v-model="verifyCode"
                  autocomplete="off"
                  maxlength="6"
                  @keyup.enter="login"
                />
                <span
                  :class="['code-btn', {'point': isGetCode}]"
                  @click="isGetCode ? getCode() : ''">
                  {{ isGetCode ? "获取验证码" : "重新获取 " + codeT + "s" }}
                </span>
              </div>
              <!-- <input type="password" placeholder="请输入验证码" v-model="verifyCode" @keyup.enter="login" /> -->
            </div>
            <!-- <div class="text-btn-box" style="justify-content: flex-end;">
              <div class="text-btn" @click="getCode">获取验证码</div>
            </div> -->
          </div>
        </div>

        <button class="solid-btn" @click="login">登录</button>
      </template>

      <div v-if="second" class="content">
        <div class="suc-remind">
          <img src="@/static/img/jj_gou.png" />
          <p>登录成功</p>
          <p style="font-size: 16px">
            <span>{{ jumpT }}</span
            >s跳转到个人中心…
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { volunteer } from "@/api/volunteer.js";
import { sessionData } from "@/static/js/local.js";

export default {
  data() {
    return {
      fir: true,
      second: false,
      jumpT: 2,
      phoneNumber: "",
      verifyCode: "",
      isGetCode: true,
      codeT: 60,
    };
  },
  created() {
    this.$cookies.remove("mobile", null, this.$cookieDomain);
    this.$cookies.remove("userInfo", null, this.$cookieDomain);

    this.$cookies.remove("token", null, this.$cookieDomain);
    this.$cookies.remove("refreshToken", null, this.$cookieDomain);
    this.$cookies.remove("exData", null, this.$cookieDomain);
    this.$cookies.remove("validTerm", null, this.$cookieDomain);
    this.$cookies.remove("regType", null, this.$cookieDomain);
    this.$cookies.remove("regType", null, this.$cookieDomain);
  },
  mounted() {},
  methods: {
    login() {
      if (!this.phoneNumber) {
        this.$message("手机号不能为空");
        return;
      }
      if (!this.verifyCode) {
        this.$message("验证码不能为空");
        return;
      }
      volunteer.getToken({
        phoneNumber: this.phoneNumber,
        verifyCode: this.verifyCode,
        userType: '1',
        mainId: this.$session.get("cmm").mainId
      }).then(res => {
        if (res && res.code == 200) {
          this.$session.set("mobile", this.phoneNumber);
          this.$cookies.set(
            "token",
            res.data.token,
            null,
            null,
            this.$cookieDomain
          );
          this.$cookies.set(
            "refreshToken",
            res.data.refreshToken,
            null,
            null,
            this.$cookieDomain
          );
          this.$cookies.set(
            "exData",
            res.data.exData,
            null,
            null,
            this.$cookieDomain
          );
          this.$cookies.set(
            "regType",
            res.data.regType,
            null,
            null,
            this.$cookieDomain
          );
          var times = Date.parse(new Date()) + (res.data.expireIn - 10) * 1000;
          this.$cookies.set("validTerm", times, null, null, this.$cookieDomain);

          this.fir = false;
          this.second = true;
          setInterval(() => {
            this.jumpT--;
            if (this.jumpT == 0) {
              this.$router.push('/volunteer');
            }
          }, 1000);
        }
      });
    },
    getCode() {
      if (!this.phoneNumber) {
        this.$message("手机号不能为空");
        return;
      }
      volunteer.getCode(this.$session.get("cmm").mainId, this.phoneNumber).then(res => {
        if(res && res.code === 200 && res.data.success) {
          this.$message.success('验证码已发送');
          this.setTime();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 验证码倒计时
    setTime() {
      if (this.codeT == 0) {
        this.isGetCode = true;
        this.codeT = 60;
        return;
      } else {
        this.isGetCode = false;
        this.codeT--;
      }
      var that = this;
      setTimeout(function() {
        that.setTime();
      }, 1000);
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>